import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Title }            from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "name",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "TITLE_LOADING" });
    },

    /**
     * Fetches the Title List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await Title.getAll(params);
        data.sort = params;
        dispatch({ type : "TITLE_LIST", data });
    },

    /**
     * Fetches a single Title
     * @param {Function} dispatch
     * @param {Number}   titleCode
     * @returns {Promise}
     */
    async fetchElem(dispatch, titleCode) {
        const data = await Title.getOne({ titleCode });
        dispatch({ type : "TITLE_ELEM", data });
    },

    /**
     * Edits/Creates a Title
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Title.edit(data);
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "TITLE_LIST", "TITLE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "TITLE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "TITLE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "TITLE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
